// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DiagnosticsService {
   $http: any
   $location: any
   endpoint: any
   session_id: any
   constructor($http: any, $location: any) {
      this.get = this.get.bind(this)
      this.$http = $http
      this.$location = $location
      this.session_id = null
      this.endpoint = "/diagnostics"
   }

   get(diagnostic = false, libraryCode='') {
      const headers = {
         'Accept': 'application/json'
      }
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (this.session_id) { headers['SUMMON-SID'] = this.session_id }

      const qs = diagnostic ? `?diagnostic=${diagnostic}` : ""
      const lc = libraryCode!='' ? `?library_code=${libraryCode}` : ""

      const requestConfig = {
         method: 'GET',
         url:`${this.endpoint}${qs}${lc}`,
         headers
      }

      return this.$http(requestConfig).then(
         (data: any) => data.data
         , (data: any) => {
            if (data.status === 401) { return this.$location.path('/') }
         })
   }
}

DiagnosticsService.$inject = ['$http', '$location']

angular.module('summonApp.services')
   .service('diagnosticsService', DiagnosticsService)
